module.exports = __webpack_public_path__ + "media/images/partners/snob-61aa37fedf7c2380ff0af79699af3351.svg";